import i18n from "@/i18n/index";

const reports = {
    nrOfResults: 0,
    thresholdConfigData: {},
    dataModelFilter: {},
    selectedTaskDetails: {},
    allTasks: [],
    filtredTasks: [],
    initialDiagramData: [],
    filterObject: { taskFilterModel: {} },
    searchInSearchFilter: {},
    currentPluginData: {},
    filteredData: {},
    nrOfFilteredResults: null,
    statsInfoPerProcess: {},
    statsPerLevels: {},
    selectedProcessReports: {
        searchPerspectives: {},
        reports: {}
    },
    selectedProcessStatistics: {},
    appMatrixUncompletedTasks: {},
    turaroundTypes: [
        { label: i18n.t("liveView.statistics.oneWeek"), value: "ONE_WEEK" },
        { label: i18n.t("liveView.statistics.twoWeeks"), value: "TWO_WEEKS" },
        { label: i18n.t("liveView.statistics.month"), value: "ONE_MONTH" }
    ],
    defaultThresholds: {
        lvThresholdFilterModel: {
            attentionPercent: 20,
            atRiskPercent: 70
        }
    },
    allDataModelList: [],
    taskDetailsById: {},
    dataToExport: {}
};

export default reports;
